import CookieConsent from "./cookieConsent";
import initIframeManager from "./iframeManager";

/**
 * This Object provides Methods to initialize the cookie consent functionality.
 */
const Consent = {
	/**
	 * Initializes the cookie consent and iframe manager.
	 * @returns {void}
	 */
	init() {
		CookieConsent.initCookieConsent();
		initIframeManager();
	},

	/**
	 * Returns the component factory function for managing cookie settings for alpine.js.
	 * @returns {Function} The component factory function that returns the component object.
	 */
	getCookieSettingsComponent() {
		return () => ({
			open() {
				window.cookieConsent.showPreferences();
			},
		});
	},
};

export default Consent;
